import React from "react";
import { storyblokEditable } from "@storyblok/react";
import {
  NODE_PARAGRAPH,
  render
} from "storyblok-rich-text-react-renderer";

import ProsAndCons from "@components/molecules/ProsAndCons";

import { ProsAndConsStoryblokProps } from "./types";

const ProsAndConsStoryblok: React.FC<ProsAndConsStoryblokProps> = ({
  blok
}) => {
  const { pros, cons } = blok;

  return (
    <ProsAndCons
      pros={render(pros, {
        nodeResolvers: {
          // eslint-disable-next-line react/no-unstable-nested-components, react/jsx-no-useless-fragment
          [NODE_PARAGRAPH]: (children) => <>{children}</>
        }
      })}
      cons={render(cons, {
        nodeResolvers: {
          // eslint-disable-next-line react/no-unstable-nested-components, react/jsx-no-useless-fragment
          [NODE_PARAGRAPH]: (children) => <>{children}</>
        }
      })}
      {...storyblokEditable(blok)}
    />
  );
};

export default ProsAndConsStoryblok;
